/*
    Author : Sohan Kumar Dash
    Project : Pearlgreen
    Date : 16-04-2019
*/

// @module Favorites
define(
	'Favorites'
,	[
		'Favorites.Router'
	]
,	function (
		FavoritesRouter
	)
{
	'use strict';

	//@class Favorites @extends ApplicationModule
	return {
		mountToApp: function (application)
		{
			return new FavoritesRouter(application);
		}
	};

});

